export default function BasicMenu() {
    return (<div className="header__mob-menu mob-menu your-menu menu-basic">
        <div className="d-flex flex-column mob-menu__body">
            <div className="icon-menu icon-menu-basic mob-menu__close">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 17L1 1M17 1L1 17" stroke="#292929" strokeWidth="0.625" stroke-linecap="round"/>
                </svg>
            </div>

            <a href="#" className="d-flex align-items-center justify-content-center mob-menu__head">
                <span className="fw-bold">ИП ТЕСТ</span>
                <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0.499999 1.48072L1.39235 0.5L6.25277 5.84495C6.33112 5.93059 6.3933 6.03244 6.43573 6.14462C6.47816 6.2568 6.5 6.37711 6.5 6.49861C6.5 6.62012 6.47816 6.74042 6.43573 6.8526C6.3933 6.96479 6.33112 7.06663 6.25277 7.15227L1.39235 12.5L0.500841 11.5193L5.06269 6.5L0.499999 1.48072Z"
                        fill="#292929"/>
                </svg>
            </a>
            <div className="d-flex align-items-center justify-content-center mob-menu__balance">
                <p>
                    Баланс
                </p>
                <p className="fw-bold">
                    12 687₽
                </p>
            </div>
            <div className="d-flex align-items-center justify-content-between mob-menu__ctr">
                <div className="dropdown header__city">
                    <button className="d-flex align-items-center dropdown-toggle bs-link gap-1" type="button"
                            id="mobMenuCity" data-bs-toggle="dropdown" aria-expanded="false">
                        <span>Москва</span>
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="mobMenuCity">
                        <li><a className="active dropdown-item" href="#" data-value="Action">Москва</a></li>
                        <li><a className="dropdown-item" href="#" data-value="Another action">Питер</a></li>
                        <li><a className="dropdown-item" href="#" data-value="Something else">Город-65</a></li>
                    </ul>
                </div>
                <a href="#" className="d-flex align-items-center justify-content-center mob-menu__phone">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M16.2018 13.9737C15.1018 13.8737 14.5018 15.3737 13.7018 15.7737C12.4018 16.4737 10.0018 13.9737 10.0018 13.9737C10.0018 13.9737 7.50184 11.5737 8.10184 10.2737C8.60184 9.47372 10.1018 8.87372 10.0018 7.77372C9.90184 6.77372 7.70184 3.17372 6.60184 4.17372C4.20184 6.37372 4.00184 7.27372 4.00184 9.07372C3.90184 12.1737 7.90184 16.0737 7.90184 16.0737C8.30184 16.4737 11.8018 20.0737 14.9018 19.9737C16.7018 19.9737 17.6018 19.7737 19.8018 17.3737C20.8018 16.2737 17.3018 14.0737 16.2018 13.9737Z"
                            fill="#FC5521"/>
                    </svg>
                </a>
            </div>
            <div className="d-flex flex-column mob-menu__list-row">
                <ul className="d-flex flex-column mob-menu__list p-0">
                    <li><a className="mob-menu__link icon-menu-catalog">Каталог</a></li>
                    <li><a href="#" className="mob-menu__link">Новинки</a></li>
                    <li><a href="#" className="mob-menu__link">Акции</a></li>

                </ul>
                <ul className="d-flex flex-column mob-menu__list p-0">
                    <li><a href="#" className="mob-menu__link">Мои заказы</a></li>
                    <li><a href="#" className="mob-menu__link">Мои организации</a></li>
                    <li><a href="#" className="mob-menu__link">Сравнение</a></li>
                </ul>
                <ul className="d-flex flex-column mob-menu__list p-0">
                    <li><a href="#" className="mob-menu__link">Личные данные</a></li>
                    <li>
                        <div className="d-flex flex-column link-drop mob-menu__link mob-menu__link-drop">
                            <div
                                className="d-flex align-items-center justify-content-between gap-3 link-drop__head">
                                <span>Покупателям</span>
                                <svg width="12" height="6" viewBox="0 0 12 6" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M11.0193 -4.81668e-07L12 0.892352L6.65505 5.75277C6.56941 5.83112 6.46756 5.8933 6.35538 5.93573C6.2432 5.97816 6.12289 6 6.00139 6C5.87988 6 5.75958 5.97816 5.6474 5.93573C5.53521 5.8933 5.43337 5.83112 5.34773 5.75277L-2.23262e-07 0.892353L0.980725 0.000840621L6 4.56269L11.0193 -4.81668e-07Z"
                                        fill="#A0A0A0"/>
                                </svg>
                            </div>
                            <ul className="d-flex flex-column gap-3 mob-menu__list">
                                <li><a href="#" className="mob-menu__link">Cсылка</a></li>
                                <li><a href="#" className="mob-menu__link">Cсылка</a></li>
                                <li><a href="#" className="mob-menu__link">Cсылка</a></li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <div className="d-flex flex-column link-drop mob-menu__link mob-menu__link-drop">
                            <div
                                className="d-flex align-items-center justify-content-between gap-3 link-drop__head">
                                <span>Сервисы</span>
                                <svg width="12" height="6" viewBox="0 0 12 6" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M11.0193 -4.81668e-07L12 0.892352L6.65505 5.75277C6.56941 5.83112 6.46756 5.8933 6.35538 5.93573C6.2432 5.97816 6.12289 6 6.00139 6C5.87988 6 5.75958 5.97816 5.6474 5.93573C5.53521 5.8933 5.43337 5.83112 5.34773 5.75277L-2.23262e-07 0.892353L0.980725 0.000840621L6 4.56269L11.0193 -4.81668e-07Z"
                                        fill="#A0A0A0"/>
                                </svg>
                            </div>
                            <ul className="d-flex flex-column gap-3 mob-menu__list">
                                <li><a href="#" className="mob-menu__link">Cсылка</a></li>
                                <li><a href="#" className="mob-menu__link">Cсылка</a></li>
                                <li><a href="#" className="mob-menu__link">Cсылка</a></li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>

            <div className="btn gray mob-menu__btn mt-auto w-100">
                Задать вопрос
            </div>
        </div>

    </div>)
}